import { render, staticRenderFns } from "./EmployeeInactivityEntryDialog.vue?vue&type=template&id=40590dde&"
import script from "./EmployeeInactivityEntryDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeInactivityEntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports